import {
  Bar,
  CartesianGrid,
  ComposedChart,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import AnalyticsTooltip from "src/components/Referral-partner/Analytics/AnalyticsTooltip";
import { TimeSeriesDataPoint } from "src/components/Referral-partner/Analytics/analyticsTypes";
import {
  AXIS_STYLES,
  GRID_STYLES,
} from "src/components/Referral-partner/Analytics/styles/chart.styles";

interface ReferralFeesProps {
  data: TimeSeriesDataPoint[];
}

const CustomerGrowth = (props: ReferralFeesProps) => {
  const { data } = props;
  return (
    <ResponsiveContainer id="customer-growth-chart" height="80%" width="95%">
      <ComposedChart data={data} margin={{ top: 20, right: 10 }}>
        <CartesianGrid vertical={false} {...GRID_STYLES} />
        <XAxis dataKey="timestamp" {...AXIS_STYLES} />

        {/* Left Y-axis for fees */}
        <YAxis yAxisId="left" {...AXIS_STYLES} orientation="left" />

        {/* Assign bars to right axis */}
        <Bar yAxisId="left" dataKey="customers" fill="#61c0eb" barSize={8}>
          <LabelList dataKey="customers" position="top" fontSize="12px" />
        </Bar>

        <Tooltip content={<AnalyticsTooltip />} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default CustomerGrowth;
